import React, { useEffect, useState, useRef } from 'react';
import { api } from '../api/client';

const BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1';

/** Файл татах: R2-д байвал сервер {url} буцаана (шууд нээнэ), DB-д байвал байтыг blob-оор татна. */
async function downloadFile(path: string, fileName: string): Promise<void> {
  const h: Record<string, string> = {};
  const token = api.getToken() || localStorage.getItem('admin_token');
  if (token) h['Authorization'] = `Bearer ${token}`;
  const pt = localStorage.getItem('platform_tenant_id'); if (pt) h['X-Tenant-Id'] = pt;
  const res = await fetch(`${BASE_URL}${path}?link=1`, { headers: h });
  if (!res.ok) throw new Error(res.status === 404 ? 'Файл олдсонгүй' : `Татаж чадсангүй (${res.status})`);
  const a = document.createElement('a');
  if ((res.headers.get('content-type') || '').includes('application/json')) {
    const j = await res.json();
    a.href = j.url; a.target = '_blank'; a.rel = 'noopener';
    a.download = fileName;
    document.body.appendChild(a); a.click(); a.remove();
    return;
  }
  const url = URL.createObjectURL(await res.blob());
  a.href = url; a.download = fileName;
  document.body.appendChild(a); a.click(); a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 2000);
}


const CATEGORIES: Record<string, string> = {
  announcement: 'Зарлал',
  meeting_minutes: 'Хурлын тэмдэглэл',
  rules: 'Дүрэм журам',
  financial_report: 'Санхүүгийн тайлан',
  maintenance_plan: 'Засварын төлөвлөгөө',
  contract: 'Гэрээ',
  other: 'Бусад',
};

const CAT_COLORS: Record<string, string> = {
  announcement: '#236844',
  meeting_minutes: '#2f7d52',
  rules: '#8b5cf6',
  financial_report: '#06b6d4',
  maintenance_plan: '#f59e0b',
  contract: '#ef4444',
  other: '#6b7280',
};

const TEMPLATE_CATEGORIES: Record<string, string> = {
  rules: 'Дүрэм журам',
  contract: 'Гэрээ',
  resolution: 'Тогтоол',
  application: 'Маягт/Анкет',
  other: 'Бусад',
};

const TEMPLATE_CAT_COLORS: Record<string, string> = {
  rules: '#8b5cf6',
  contract: '#ef4444',
  resolution: '#06b6d4',
  application: '#f59e0b',
  other: '#6b7280',
};

interface Doc {
  id: string;
  title: string;
  content: string;
  category: string;
  is_pinned: boolean;
  is_published: boolean;
  views_count: number;
  file_name?: string | null;
  file_size?: number;
  has_file?: boolean;
  created_at: string;
}

const MAX_DOC_FILE_SIZE = 5 * 1024 * 1024; // 5MB

function formatFileSize(bytes: number) {
  if (!bytes) return '';
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

interface Template {
  id: string;
  title: string;
  description: string;
  category: string;
  file_name: string;
  file_size: number;
  download_count: number;
  created_at: string;
}

export default function DocumentsPage() {
  const [tab, setTab] = useState<'docs' | 'templates'>('docs');

  return (
    <div>
      <div style={{ display: 'flex', gap: 0, marginBottom: 24, borderBottom: '2px solid #e5e7eb' }}>
        <button onClick={() => setTab('docs')}
          style={{
            padding: '12px 24px', border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: 600,
            background: 'none', color: tab === 'docs' ? '#236844' : '#9ca3af',
            borderBottom: tab === 'docs' ? '2px solid #236844' : '2px solid transparent',
            marginBottom: -2,
          }}>
          Баримт бичиг
        </button>
        <button onClick={() => setTab('templates')}
          style={{
            padding: '12px 24px', border: 'none', cursor: 'pointer', fontSize: 15, fontWeight: 600,
            background: 'none', color: tab === 'templates' ? '#236844' : '#9ca3af',
            borderBottom: tab === 'templates' ? '2px solid #236844' : '2px solid transparent',
            marginBottom: -2,
          }}>
          Загвар баримт бичиг
        </button>
      </div>

      {tab === 'docs' ? <DocsTab /> : <TemplatesTab />}
    </div>
  );
}

/* ─── Documents Tab ─── */

function DocsTab() {
  const [docs, setDocs] = useState<Doc[]>([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [showForm, setShowForm] = useState(false);
  const [editDoc, setEditDoc] = useState<Doc | null>(null);
  const [form, setForm] = useState({ title: '', content: '', category: 'announcement', is_pinned: false, is_published: true });
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [removeFile, setRemoveFile] = useState(false);
  const [fileError, setFileError] = useState('');
  const [saving, setSaving] = useState(false);
  const fileRef = useRef<HTMLInputElement>(null);

  const load = async () => {
    try {
      const url = filter ? `/admin/documents?category=${filter}` : '/admin/documents';
      const data = await api.get(url);
      setDocs(data.items || []);
      setTotal(data.total || 0);
    } catch { /* ignore */ }
    setLoading(false);
  };

  useEffect(() => { load(); }, [filter]);

  const pickFile = (f: File | null) => {
    setFileError('');
    if (f && f.size > MAX_DOC_FILE_SIZE) {
      setFileError('Файлын хэмжээ 5MB-аас хэтэрсэн байна');
      setSelectedFile(null);
      if (fileRef.current) fileRef.current.value = '';
      return;
    }
    setSelectedFile(f);
    if (f) setRemoveFile(false);
  };

  const resetForm = () => {
    setForm({ title: '', content: '', category: 'announcement', is_pinned: false, is_published: true });
    setSelectedFile(null);
    setRemoveFile(false);
    setFileError('');
    if (fileRef.current) fileRef.current.value = '';
  };

  const handleSubmit = async () => {
    if (!form.title.trim() || saving) return;
    setSaving(true);
    try {
      const fd = new FormData();
      fd.append('title', form.title);
      fd.append('content', form.content);
      fd.append('category', form.category);
      fd.append('is_pinned', String(form.is_pinned));
      fd.append('is_published', String(form.is_published));
      if (selectedFile) fd.append('file', selectedFile);
      if (editDoc && removeFile) fd.append('remove_file', 'true');

      const token = localStorage.getItem('admin_token');
      const url = editDoc ? `${BASE_URL}/admin/documents/${editDoc.id}` : `${BASE_URL}/admin/documents`;
      const res = await fetch(url, {
        method: editDoc ? 'PUT' : 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: fd,
      });
      if (!res.ok) {
        let msg = 'Хадгалахад алдаа гарлаа';
        try { msg = (await res.json())?.detail || msg; } catch {}
        setFileError(msg);
        setSaving(false);
        return;
      }
      setShowForm(false);
      setEditDoc(null);
      resetForm();
      load();
    } catch {
      setFileError('Сүлжээний алдаа');
    }
    setSaving(false);
  };

  const handleDownload = async (d: Doc) => {
    try { await downloadFile(`/admin/documents/${d.id}/download`, d.file_name || 'document'); }
    catch (e: any) { window.alert(e?.message || 'Файл татаж чадсангүй'); }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Устгах уу?')) return;
    try {
      await api.delete(`/admin/documents/${id}`);
      load();
    } catch { /* ignore */ }
  };

  const openEdit = (d: Doc) => {
    setEditDoc(d);
    setForm({ title: d.title, content: d.content, category: d.category, is_pinned: d.is_pinned, is_published: d.is_published });
    setSelectedFile(null);
    setRemoveFile(false);
    setFileError('');
    if (fileRef.current) fileRef.current.value = '';
    setShowForm(true);
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#5f6f66' }}>Уншиж байна...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 24, color: '#1c2b22', margin: 0 }}>
          Баримт бичиг ({total})
        </h2>
        <button onClick={() => { setEditDoc(null); resetForm(); setShowForm(true); }}
          style={{ background: '#236844', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
          + Шинэ баримт
        </button>
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('')}
          style={{ padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
            background: !filter ? '#236844' : '#e8e5dc', color: !filter ? '#fff' : '#5f6f66' }}>
          Бүгд
        </button>
        {Object.entries(CATEGORIES).map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)}
            style={{ padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
              background: filter === key ? CAT_COLORS[key] : '#e8e5dc', color: filter === key ? '#fff' : '#5f6f66' }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
        {docs.map(d => (
          <div key={d.id} style={{
            background: '#fff', borderRadius: 12, padding: 20,
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
            borderLeft: d.is_pinned ? '4px solid #ffd166' : '4px solid transparent',
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                  {d.is_pinned && <span style={{ fontSize: 14 }} title="Бэхэлсэн">📌</span>}
                  <h3 style={{ margin: 0, fontSize: 16, fontWeight: 600, color: '#1c2b22' }}>{d.title}</h3>
                </div>
                <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                  <span style={{
                    fontSize: 11, padding: '2px 8px', borderRadius: 12,
                    background: `${CAT_COLORS[d.category] || '#6b7280'}15`,
                    color: CAT_COLORS[d.category] || '#6b7280',
                    fontWeight: 600,
                  }}>
                    {CATEGORIES[d.category] || d.category}
                  </span>
                  {!d.is_published && (
                    <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 12, background: '#fef3c7', color: '#92400e', fontWeight: 600 }}>
                      Ноорог
                    </span>
                  )}
                </div>
                <p style={{ margin: 0, fontSize: 14, color: '#5f6f66', lineHeight: 1.5,
                  display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' as any, overflow: 'hidden' }}>
                  {d.content}
                </p>
              </div>
              <div style={{ display: 'flex', gap: 8, marginLeft: 16 }}>
                <button onClick={() => openEdit(d)}
                  style={{ background: '#f0f9f4', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', color: '#236844', fontSize: 13 }}>
                  Засах
                </button>
                <button onClick={() => handleDelete(d.id)}
                  style={{ background: '#fef2f2', border: 'none', borderRadius: 6, padding: '6px 12px', cursor: 'pointer', color: '#ef4444', fontSize: 13 }}>
                  Устгах
                </button>
              </div>
            </div>
            <div style={{ display: 'flex', gap: 16, marginTop: 10, fontSize: 12, color: '#9ca3af', alignItems: 'center' }}>
              <span>👁 {d.views_count} үзсэн</span>
              <span>{d.created_at ? new Date(d.created_at).toLocaleDateString('mn-MN') : ''}</span>
              {d.has_file && (
                <button onClick={() => handleDownload(d)}
                  style={{ background: '#f0f9f4', border: 'none', borderRadius: 6, padding: '4px 10px', cursor: 'pointer', color: '#236844', fontSize: 12, fontWeight: 600, display: 'flex', alignItems: 'center', gap: 4 }}
                  title={`Татах: ${d.file_name || ''}`}>
                  ⬇ Татах · {d.file_name} {d.file_size ? `(${formatFileSize(d.file_size)})` : ''}
                </button>
              )}
            </div>
          </div>
        ))}
        {docs.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af' }}>Баримт бичиг олдсонгүй</div>
        )}
      </div>

      {showForm && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowForm(false)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 560, maxHeight: '80vh', overflow: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 20, color: '#1c2b22', marginTop: 0 }}>
              {editDoc ? 'Баримт засах' : 'Шинэ баримт'}
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Гарчиг</label>
                <input value={form.title} onChange={e => setForm({ ...form, title: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                  placeholder="Баримтын гарчиг" />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Ангилал</label>
                <select value={form.category} onChange={e => setForm({ ...form, category: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}>
                  {Object.entries(CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Агуулга</label>
                <textarea value={form.content} onChange={e => setForm({ ...form, content: e.target.value })}
                  rows={8}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }}
                  placeholder="Баримтын агуулга..." />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>
                  Хавсралт файл (сонголтоор, дээд тал нь 5MB)
                </label>
                {editDoc?.has_file && !selectedFile && !removeFile && (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8, fontSize: 13, color: '#5f6f66' }}>
                    <span>📎 {editDoc.file_name} {editDoc.file_size ? `(${formatFileSize(editDoc.file_size)})` : ''}</span>
                    <button type="button" onClick={() => setRemoveFile(true)}
                      style={{ background: '#fef2f2', border: 'none', borderRadius: 6, padding: '3px 10px', cursor: 'pointer', color: '#ef4444', fontSize: 12 }}>
                      Устгах
                    </button>
                  </div>
                )}
                {editDoc?.has_file && removeFile && (
                  <div style={{ fontSize: 13, color: '#ef4444', marginBottom: 8 }}>
                    Одоо байгаа файлыг устгана.{' '}
                    <button type="button" onClick={() => setRemoveFile(false)}
                      style={{ background: 'none', border: 'none', color: '#236844', cursor: 'pointer', fontSize: 13, textDecoration: 'underline' }}>
                      Болих
                    </button>
                  </div>
                )}
                <input ref={fileRef} type="file"
                  accept=".pdf,.doc,.docx,.xls,.xlsx,.jpg,.jpeg,.png,.txt"
                  onChange={e => pickFile(e.target.files?.[0] || null)}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
                {editDoc?.has_file && (
                  <p style={{ margin: '4px 0 0', fontSize: 12, color: '#9ca3af' }}>Шинэ файл сонговол хуучныг солино.</p>
                )}
                {fileError && <p style={{ margin: '6px 0 0', fontSize: 13, color: '#ef4444' }}>{fileError}</p>}
              </div>
              <div style={{ display: 'flex', gap: 16 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={form.is_pinned} onChange={e => setForm({ ...form, is_pinned: e.target.checked })} />
                  Бэхлэх (📌)
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={form.is_published} onChange={e => setForm({ ...form, is_published: e.target.checked })} />
                  Нийтлэх
                </label>
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowForm(false)}
                  style={{ padding: '10px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                  Цуцлах
                </button>
                <button onClick={handleSubmit} disabled={!form.title.trim() || saving}
                  style={{ padding: '10px 20px', background: '#236844', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14, opacity: (form.title.trim() && !saving) ? 1 : 0.5 }}>
                  {saving ? 'Хадгалж байна...' : (editDoc ? 'Хадгалах' : 'Нэмэх')}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}


/* ─── Templates Tab ─── */

function TemplatesTab() {
  const [templates, setTemplates] = useState<Template[]>([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('');
  const [showUpload, setShowUpload] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadForm, setUploadForm] = useState({ title: '', description: '', category: 'other' });
  const fileRef = useRef<HTMLInputElement>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [isPlatformAdmin, setIsPlatformAdmin] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem('admin_user');
      if (stored) {
        const u = JSON.parse(stored);
        setIsPlatformAdmin(u.role === 'platform_admin');
      }
    } catch {}
  }, []);

  const load = async () => {
    try {
      const url = filter ? `/admin/document-templates?category=${filter}` : '/admin/document-templates';
      const data = await api.get(url);
      setTemplates(data.items || []);
    } catch { /* ignore */ }
    setLoading(false);
  };

  useEffect(() => { load(); }, [filter]);

  const handleUpload = async () => {
    if (!selectedFile || !uploadForm.title.trim()) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('title', uploadForm.title);
      formData.append('description', uploadForm.description);
      formData.append('category', uploadForm.category);
      formData.append('file', selectedFile);

      const token = localStorage.getItem('admin_token');
      await fetch(`${BASE_URL}/admin/document-templates`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
        body: formData,
      });

      setShowUpload(false);
      setUploadForm({ title: '', description: '', category: 'other' });
      setSelectedFile(null);
      load();
    } catch { /* ignore */ }
    setUploading(false);
  };

  const handleDownload = async (t: Template) => {
    try { await downloadFile(`/admin/document-templates/${t.id}/download`, t.file_name); load(); }
    catch (e: any) { window.alert(e?.message || 'Файл татаж чадсангүй'); }
  };

  const handleDelete = async (id: string) => {
    if (!window.confirm('Загвар баримт устгах уу?')) return;
    try {
      await api.delete(`/admin/document-templates/${id}`);
      load();
    } catch { /* ignore */ }
  };

  const formatSize = (bytes: number) => {
    if (bytes < 1024) return `${bytes} B`;
    return `${(bytes / 1024).toFixed(1)} KB`;
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#5f6f66' }}>Уншиж байна...</div>;

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <div>
          <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 24, color: '#1c2b22', margin: 0 }}>
            Загвар баримт бичиг ({templates.length})
          </h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#9ca3af' }}>
            СӨХ-ийн үйл ажиллагаанд ашиглах загвар баримтууд. Татаж авч ашиглана уу.
          </p>
        </div>
        {isPlatformAdmin && (
          <button onClick={() => { setShowUpload(true); setSelectedFile(null); setUploadForm({ title: '', description: '', category: 'other' }); }}
            style={{ background: '#236844', color: '#fff', border: 'none', borderRadius: 8, padding: '10px 20px', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>
            + Загвар нэмэх
          </button>
        )}
      </div>

      <div style={{ display: 'flex', gap: 8, marginBottom: 20, flexWrap: 'wrap' }}>
        <button onClick={() => setFilter('')}
          style={{ padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
            background: !filter ? '#236844' : '#e8e5dc', color: !filter ? '#fff' : '#5f6f66' }}>
          Бүгд
        </button>
        {Object.entries(TEMPLATE_CATEGORIES).map(([key, label]) => (
          <button key={key} onClick={() => setFilter(key)}
            style={{ padding: '6px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13,
              background: filter === key ? (TEMPLATE_CAT_COLORS[key] || '#6b7280') : '#e8e5dc',
              color: filter === key ? '#fff' : '#5f6f66' }}>
            {label}
          </button>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 16 }}>
        {templates.map(t => {
          const color = TEMPLATE_CAT_COLORS[t.category] || '#6b7280';
          return (
            <div key={t.id} style={{
              background: '#fff', borderRadius: 12, padding: 20,
              boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
              display: 'flex', flexDirection: 'column', gap: 12,
            }}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: 12,
                  background: `${color}15`, display: 'flex', alignItems: 'center', justifyContent: 'center',
                  flexShrink: 0,
                }}>
                  <span style={{ fontSize: 22 }}>📄</span>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600, color: '#1c2b22', lineHeight: 1.3 }}>{t.title}</h3>
                  <span style={{
                    fontSize: 11, padding: '2px 8px', borderRadius: 12, marginTop: 4, display: 'inline-block',
                    background: `${color}15`, color, fontWeight: 600,
                  }}>
                    {TEMPLATE_CATEGORIES[t.category] || t.category}
                  </span>
                </div>
              </div>

              {t.description && (
                <p style={{ margin: 0, fontSize: 13, color: '#5f6f66', lineHeight: 1.4,
                  display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical' as any, overflow: 'hidden' }}>
                  {t.description}
                </p>
              )}

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 'auto' }}>
                <div style={{ fontSize: 12, color: '#9ca3af' }}>
                  <span>{formatSize(t.file_size)}</span>
                  <span style={{ margin: '0 8px' }}>·</span>
                  <span>{t.download_count} татсан</span>
                </div>
                <div style={{ display: 'flex', gap: 6 }}>
                  <button onClick={() => handleDownload(t)}
                    style={{ background: '#f0f9f4', border: 'none', borderRadius: 6, padding: '6px 14px', cursor: 'pointer', color: '#236844', fontSize: 13, fontWeight: 600 }}>
                    Татах
                  </button>
                  {isPlatformAdmin && (
                    <button onClick={() => handleDelete(t.id)}
                      style={{ background: '#fef2f2', border: 'none', borderRadius: 6, padding: '6px 10px', cursor: 'pointer', color: '#ef4444', fontSize: 13 }}>
                      Устгах
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
        {templates.length === 0 && (
          <div style={{ textAlign: 'center', padding: 40, color: '#9ca3af', gridColumn: '1 / -1' }}>
            Загвар баримт бичиг олдсонгүй
          </div>
        )}
      </div>

      {showUpload && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}
          onClick={() => setShowUpload(false)}>
          <div style={{ background: '#fff', borderRadius: 16, padding: 32, width: 500, maxHeight: '80vh', overflow: 'auto' }}
            onClick={e => e.stopPropagation()}>
            <h3 style={{ fontFamily: "'Inter'", fontWeight: 700, fontSize: 20, color: '#1c2b22', marginTop: 0 }}>
              Загвар баримт нэмэх
            </h3>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Гарчиг</label>
                <input value={uploadForm.title} onChange={e => setUploadForm({ ...uploadForm, title: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                  placeholder="Баримтын нэр" />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Тайлбар</label>
                <textarea value={uploadForm.description} onChange={e => setUploadForm({ ...uploadForm, description: e.target.value })}
                  rows={3}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, resize: 'vertical', boxSizing: 'border-box' }}
                  placeholder="Товч тайлбар..." />
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Ангилал</label>
                <select value={uploadForm.category} onChange={e => setUploadForm({ ...uploadForm, category: e.target.value })}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}>
                  {Object.entries(TEMPLATE_CATEGORIES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                </select>
              </div>
              <div>
                <label style={{ fontSize: 13, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Файл (DOCX)</label>
                <input ref={fileRef} type="file" accept=".docx,.doc,.pdf,.xlsx,.xls"
                  onChange={e => setSelectedFile(e.target.files?.[0] || null)}
                  style={{ width: '100%', padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
              </div>
              <div style={{ display: 'flex', gap: 12, justifyContent: 'flex-end' }}>
                <button onClick={() => setShowUpload(false)}
                  style={{ padding: '10px 20px', border: '1px solid #d1d5db', borderRadius: 8, background: '#fff', cursor: 'pointer', fontSize: 14 }}>
                  Цуцлах
                </button>
                <button onClick={handleUpload} disabled={!uploadForm.title.trim() || !selectedFile || uploading}
                  style={{ padding: '10px 20px', background: '#236844', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600, fontSize: 14,
                    opacity: (uploadForm.title.trim() && selectedFile && !uploading) ? 1 : 0.5 }}>
                  {uploading ? 'Илгээж байна...' : 'Нэмэх'}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
